import { Badge } from "flowbite-react";
import { useTranslation } from "react-i18next";

export const UnassignedBadge = () => {
  const { t } = useTranslation();

  return (
    <Badge color="gray" size="xs">
      {t("common.unassigned")}
    </Badge>
  );
};
